export default "__VITE_ASSET__DVb08uvH__"